import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { PointLabelStyleApiModel } from '../../../types/models/point-label-style.model';
import { SearchPointLabelStylesApiRequest } from '../../../types/requests/point-label-styles/search-point-label-styles.request';
import { CreatePointLabelStyleApiRequest } from '../../../types/requests/point-label-styles/create-point-label-style.request';
import { UpdatePointLabelStyleApiRequest } from '../../../types/requests/point-label-styles/update-point-label-style.request';
import { GetPointLabelStyleApiRequest } from '../../../types/requests/point-label-styles/get-point-label-style.request';
import { DeletePointLabelStyleApiRequest } from '../../../types/requests/point-label-styles/delete-point-label-style.request';
import { AddTemplateToPointLabelStyleApiRequest } from '../../../types/requests/point-label-styles/add-template-to-point-label-style.request';
import { RemoveTemplateFromPointLabelStyleApiRequest } from '../../../types/requests/point-label-styles/remove-template-from-point-label-style.request';

export const createPointLabelStyle = (params: CreatePointLabelStyleApiRequest) =>
  client.post<PointLabelStyleApiModel>('/point-label-styles', params);

export const updatePointLabelStyle = ({ pointLabelStyleId, ...params }: UpdatePointLabelStyleApiRequest) =>
  client.patch<PointLabelStyleApiModel>(`/point-label-styles/${pointLabelStyleId}`, params);

export const getPointLabelStyle = <T extends PointLabelStyleApiModel>({
  pointLabelStyleId,
  ...params
}: GetPointLabelStyleApiRequest) => client.get<T>(`/point-label-styles/${pointLabelStyleId}`, { params });

export const searchPointLabelStyles = <T extends PointLabelStyleApiModel>(params: SearchPointLabelStylesApiRequest) =>
  client.get<CursorPaginatedApiResponse<T>>(`/point-label-styles`, { params });

export const addTemplateToPointLabelStyle = ({
  pointLabelStyleId,
  templateId,
}: AddTemplateToPointLabelStyleApiRequest) =>
  client.post<void>(`/point-label-styles/${pointLabelStyleId}/templates/${templateId}`);

export const removeTemplateFromPointLabelStyle = ({
  pointLabelStyleId,
  templateId,
}: RemoveTemplateFromPointLabelStyleApiRequest) =>
  client.delete<void>(`/point-label-styles/${pointLabelStyleId}/templates/${templateId}`);

export const deletePointLabelStyle = ({ pointLabelStyleId }: DeletePointLabelStyleApiRequest) =>
  client.delete<void>(`/point-label-styles/${pointLabelStyleId}`);
